import React from 'react'
import PropTypes from 'prop-types'
import { sizes } from '@qflow/theme'

export function Water({
  size = sizes.MEDIUM,
  colour = 'currentColor',
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      viewBox="-2 0 13.33333 12"
      {...props}
      style={{ width: size, height: size }}
    >
      <g fill={colour} fillRule="evenodd">
        <path d="M4.9987 0.166626C1.88953 2.82079 0.332031 5.11329 0.332031 7.04996C0.332031 9.95496 2.5487 11.8333 4.9987 11.8333C7.4487 11.8333 9.66537 9.95496 9.66537 7.04996C9.66537 5.11329 8.10786 2.82079 4.9987 0.166626ZM4.9987 10.6666C3.04453 10.6666 1.4987 9.16746 1.4987 7.04996C1.4987 5.68496 2.6362 3.87663 4.9987 1.71829C7.3612 3.87663 8.4987 5.67913 8.4987 7.04996C8.4987 9.16746 6.95287 10.6666 4.9987 10.6666ZM2.5662 7.16663C2.78203 7.16663 2.95703 7.31829 2.99786 7.52829C3.23703 8.82329 4.32786 9.26663 5.1212 9.20246C5.37203 9.19079 5.58203 9.38913 5.58203 9.63996C5.58203 9.87329 5.39536 10.0658 5.16203 10.0775C3.91953 10.1533 2.46703 9.44163 2.13453 7.67413C2.08786 7.41163 2.29786 7.16663 2.5662 7.16663Z" />
      </g>
    </svg>
  )
}

Water.propTypes = {
  colour: PropTypes.string,
  size: PropTypes.string
}
